// extracted by mini-css-extract-plugin
module.exports = {"dot":"MiniLoader_dot__NNoTx","dot1":"MiniLoader_dot1__1ZIPw","dot2":"MiniLoader_dot2__1IHgn","dot3":"MiniLoader_dot3__3dIY5"};